import { Button } from '@mui/material'
import React from 'react'
import { ModalButtonContainer, NegativeModalButton, PositiveModalButton } from '../../components/Button'
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useModal } from '../../components/modal';
import { CustomTextField } from '../../components/TextFields';
import VideoUploader from '../../components/uploader/videoUploader';

const schema = yup.object().shape({
    title: yup.string().required("عنوان الزامی است."),
    video: yup.string().required("ویدیو الزامی است."),
});

function AddModal() {
    const { setShow } = useModal();
    const {
        setValue,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm({
        resolver: yupResolver(schema),
    });
    return (
        <React.Fragment>
            <CustomTextField
                label="عنوان"
                error={!!errors.title}
                helperText={errors.title?.message}
                onChange={(e) => setValue("title", e.target.value)}
                placeholder='عنوان را وارد کنید.'
                variant="outlined"
                required
            />
            <VideoUploader required title="ویدیو" />
            <ModalButtonContainer>
                <Button
                    style={NegativeModalButton}
                    sx={{
                        color: "divider",
                        bgcolor: "primary.main",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        borderColor: "divider",
                        ":hover": {
                            bgcolor: "divider",
                            color: "primary.main"
                        },
                    }}
                    onClick={() => setShow(false)}
                >
                    انصراف
                </Button>
                <Button
                    style={PositiveModalButton}
                    sx={{
                        ":hover": {
                            bgcolor: "customColors.purple",
                            color: "secondary.main"
                        },
                    }}
                >
                    تایید
                </Button>
            </ModalButtonContainer >
        </React.Fragment>
    )
}

export default AddModal
